import React from "react";
import logo from "./assets/images/whitelogo.webp";
import { Link } from "react-router-dom";
import { FaSquareFacebook } from "react-icons/fa6";
import { RiInstagramFill } from "react-icons/ri";
import { BsSendFill } from "react-icons/bs";

function Footer() {
  return (
    <>
      <footer className="footer-section">
        <div className="container">
          <div className="footer-cta pt-5 pb-3">
            <div className="row">
              <div className="col-xl-4 col-md-4 mb-30 mb-3">
                <div className="single-cta">
                  <i className="fas fa-map-marker-alt"></i>
                  <div className="cta-text">
                    <h4>Find us</h4>
                    <span>
                      Airport Road Mohanbari, Near Dibrugarh Airport, City-
                      Dibrugarh (ASSAM) - 786012
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-md-4 mb-30 mb-3">
                <div className="single-cta">
                  <i className="fas fa-phone"></i>
                  <div className="cta-text">
                    <h4>Emergency Contact</h4>
                    <span>(+91) 7576825040</span>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-md-4 mb-30 mb-3">
                <div className="single-cta">
                  <i className="far fa-envelope-open"></i>
                  <div className="cta-text">
                    <h4>Mail us</h4>
                    <span>support@dibrugo.com</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="footer-content pt-4 pb-5">
            <div className="row">
              <div className="col-xl-4 col-lg-4 mb-50">
                <div className="footer-widget">
                  <div className="footer-logo">
                    <Link to="/">
                      <img src={logo} className="img-fluid" alt="logo" />
                    </Link>
                  </div>
                  <div className="footer-text">
                    <p>
                      DibruGo is a reliable cab service based in Dibrugarh,
                      offering safe, comfortable, and affordable rides across
                      Assam and Arunachal Pradesh. With professional drivers,
                      well-maintained vehicles, and 24×7 availability, DibruGo
                      ensures smooth city travel, airport transfers, and
                      long-distance journeys with convenience and trust.
                    </p>
                  </div>
                  <div className="footer-social-icon mb-3">
                    <span>Follow us</span>
                    <a href="#">
                      <FaSquareFacebook />
                    </a>
                    <a href="#">
                      <RiInstagramFill />
                    </a>
                    <a href="#">
                      <i className="fab fa-google-plus-g google-bg"></i>
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-lg-4 col-md-6 mb-30 pb-3">
                <div className="footer-widget">
                  <div className="footer-widget-heading">
                    <h3>Useful Links</h3>
                  </div>
                  <ul style={{ fontSize: "14px" }}>
                    <li>
                      <Link to="/">Home</Link>
                    </li>
                    <li>
                      <Link to="/privacy-policy">Privacy Policy</Link>
                    </li>
                    <li>
                      <Link to="/about-us-dibrugo">About us</Link>
                    </li>
                    <li>
                      <Link to="/terms-of-service">Terms of Service</Link>
                    </li>
                    <li>
                      <Link to="/contact-us-dibrugo">Contact us</Link>
                    </li>
                    <li>
                      <Link to="/terms-of-service">Refund Policy</Link>
                    </li>
                    <li>
                      <Link to="/my-bookings">My Bookings</Link>
                    </li>

                    <li>
                      <Link to="/our-cars">Our Cars</Link>
                    </li>

                    <li>
                      <Link to="/admin-live-bookings">Admin Login</Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-xl-4 col-lg-4 col-md-6 mb-50">
                <div className="footer-widget">
                  <div className="footer-widget-heading">
                    <h3>Subscribe</h3>
                  </div>
                  <div className="footer-text mb-25">
                    <p>
                      Don’t miss to subscribe to our new feeds, kindly fill the
                      form below.
                    </p>
                  </div>
                  <div className="subscribe-form">
                    <form>
                      <input type="text" placeholder="Email Address" />
                      <button>
                        <BsSendFill className="text-light icon" />
                      </button>
                    </form>
                  </div>
                  <p
                    className="text-light mt-4 mb-0"
                    style={{
                      letterSpacing: "0.5px",
                      color: "#a8a8a8",
                      fontSize: "13px",
                    }}
                  >
                    <span style={{ color: "grey" }}>GSTIN:</span>{" "}
                    18DTZPD9493P1Z6
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="copyright-area">
          <div className="container">
            <div className="row">
              <div className="col-xl-6 col-lg-6 text-center text-lg-left">
                <div className="copyright-text">
                  <p>
                    Copyright &copy; 2026, All Right Reserved{" "}
                    <Link to="/">DibruGo</Link>
                  </p>
                </div>
              </div>
              <div className="col-xl-6 col-lg-6 text-right">
                <div className="footer-menu text-center"><p style={{color:'grey', fontSize:'12px', marginBottom:'0px'}}>Developed by <a href="tel: 9717619858" style={{color:'#fd9a12'}}>+91 9717619858</a></p></div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;
